export const DATA_TABLE_DATE_FORMAT = 'YYYY-MM-DD';

export const DATA_TABLE_COLUMN_TYPE_NUMBER = 'number';
export const DATA_TABLE_COLUMN_TYPE_STRING = 'string';
export const DATA_TABLE_COLUMN_TYPE_DATE = 'date';
export const DATA_TABLE_COLUMN_TYPE_SELECT = 'select';
export const DATA_TABLE_COLUMN_TYPE_STATUS = 'status';
export const DATA_TABLE_COLUMN_TYPE_HIDDEN = 'hidden';
export const DATA_TABLE_COLUMN_TYPE_LINK = 'link';
export const DATA_TABLE_COLUMN_TYPE_VIEW = 'view';
export const DATA_TABLE_COLUMN_TYPE_AUTHOR = 'author';
export const DATA_TABLE_COLUMN_TYPE_PROCESS_STATUS = 'process_status';
export const DATA_TABLE_COLUMN_TYPE_ACTIONS = 'actions';
export const DATA_TABLE_COLUMN_TYPE_ICON_STATUS = 'icon_status';
export const DATA_TABLE_COLUMN_TYPE_FORMATTED_MESSAGE = 'formatted_message';

export const DATA_TABLE_FILTER_TYPE_STRING = 'string';
export const DATA_TABLE_FILTER_TYPE_COMPLEX_STRING = 'complex-string';
export const DATA_TABLE_FILTER_TYPE_DATE = 'date';
export const DATA_TABLE_FILTER_TYPE_SELECT = 'select';
export const DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE = 'autocomplete-single';
export const DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_MULTI = 'autocomplete-multi';



// WEBPACK FOOTER //
// ./src/constants/dataTable.js